import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=c7f288b0&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./report-card.css?vue&type=style&index=0&lang=css&"
import style1 from "./add.css?vue&type=style&index=1&id=c7f288b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f288b0",
  null
  
)

export default component.exports